/* angular:styles/component:css;37329e03f35742eb188b64c25d703e279a5d30cd46e4b7cfa84c7e71430c1b64;/src/src/app/shared/components/schedule/form/daily/daily.ts */
.datetime-button::part(native) {
  background-color: var(--ion-color-toolbar-primary);
}
.datetime-button::part(content) {
  padding: 0 !important;
}
.picker-opts {
  --background: none;
}
/*# sourceMappingURL=daily.css.map */
